import { SimpleListEntitiesAllowedEnum, SimpleListEntitiesRequest, SimpleListEntitiesResponse } from '@/api/resources/common/simple-list-entities/simple-list-entities.dto'
import { StatisticalAnalysisSimpleListEntitiesAllowedEnum } from '@/modules/statistical-analysis-module/shared/services/statistical-analysis-simple-list/statistical-analysis-simple-list.dto'
import axios from 'axios'

class StatisticalAnalysisSimpleListEntity {
    async getListOfEntity(entity: SimpleListEntitiesAllowedEnum | StatisticalAnalysisSimpleListEntitiesAllowedEnum, params?: SimpleListEntitiesRequest): Promise<SimpleListEntitiesResponse> {
        const response = await axios.get<SimpleListEntitiesResponse>(`/statisticAnalysis/simpleList/${entity}`, { params })
        return response.data
    }
}

export const statisticalAnalysisSimpleListEntity = new StatisticalAnalysisSimpleListEntity()
